import { isVideoStation } from '@app/core/stations/helpers';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { isFaceRecognitionEnabled } from '@app/modules/persons/appearances/is-face-recognition-enabled';
import { isDiarizationSegmentsEnabled } from '../../../../diarization/isDiarizationSegmentsEnabled';
import { isTranscriptionEnabled } from '../../../../diarization/isTranscriptionEnabled';
import { useStreamSettingsStore } from '../../../../stores/stream-screen-settings.store';

/** La estación tiene voz o rostro habilitado (misma regla que DiarizationProvider para voz). */
export function usePersonsEnabledForStation(): boolean {
  const station = useActiveStation();
  const voice =
    isDiarizationSegmentsEnabled(station) ||
    (!isVideoStation(station) && isTranscriptionEnabled(station));
  return voice || isFaceRecognitionEnabled(station);
}

/** Feature habilitada en la estación y toggle "Personas" activo. */
export function usePersonsShow(): boolean {
  const enabled = usePersonsEnabledForStation();
  const active = useStreamSettingsStore((state) => state.audit.persons);
  return enabled && active;
}
